var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'custom-select',
    {
      'has-user-prefix': _vm.hasUserPrefix,
      'is-focused': _vm.isFocused,
      'has-value': _vm.hasValue,
    } ]},[_c('el-select',_vm._g(_vm._b({ref:"select",class:['main-select', _vm.customClass],attrs:{"value":_vm.value}},'el-select',_vm.$attrs,false),_vm.mergedListeners),[_c('template',{slot:"prefix"},[_c('span',{staticClass:"floating-label"},[_vm._v(_vm._s(_vm.label))]),_vm._t("prefix")],2),(_vm.$slots.empty)?_c('template',{slot:"empty"},[_vm._t("empty")],2):_vm._e(),_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }